/* eslint-disable handle-callback-err */
<template lang="pug">
  #form-profile(row wrap)
    //-- TITULO 1
    v-layout(row wrap)
      v-flex(xs1 sm1 md2 lg2)
      v-flex(xs10 sm10 md8 lg8)
        h2.subtitle-profile.omnesMedium Datos de contacto
      v-flex(xs1 sm1 md2 lg2)
    //-- FORMULARIOS
    v-layout(row wrap)
      v-flex(xs1 sm1 md2 lg2)
      v-flex(xs10 sm10 md8 lg8)
        v-text-field#inputCellphone(label="Celular" outline placeholder="-" v-model='form.celular' @keypress="onlyNumbers($event)" :value="form.celular")
          template(v-slot:append='')
            img(:src="icons.iconPencil" alt="iconPencil")
      v-flex(xs1 sm1 md2 lg2)
    //-- FORMULARIOS
    v-layout(row wrap)
      v-flex(xs1 sm1 md2 lg2)
      v-flex(xs10 sm10 md8 lg8)
        v-text-field(label="Correo electrónico" id="inputEmail" outline placeholder="-" v-model='form.correo' @input="$v.form.correo.$touch()" @blur="$v.form.correo.$touch()" :error-messages="correoErrors")
          template(v-slot:append='')
            img(:src="icons.iconPencil" alt="iconPencil")
      v-flex(xs1 sm1 md2 lg2)
    //-- TITULO 2
    v-layout(row wrap)
      v-flex(xs1 sm1 md2 lg2)
      v-flex(xs10 sm10 md8 lg8)
        h2.subtitle-profile(style="margin-bottom: 0;") Cambia tu contraseña
        p.password-description.mt-2.mb-3 Por tu seguridad, la nueva contraseña debe  ser distinta a la anterior y cumplir con los requisitos mínimos especificados en la lista.
      v-flex(xs1 sm1 md2 lg2)
    //-- FORMULARIOS - Contraseña actual (solo si se está cambiando la contraseña)
    v-layout(row wrap)
      v-flex(xs1 sm1 md2 lg2)
      v-flex(xs10 sm10 md8 lg8).current-password
        v-text-field#inputCurrentPassword(label="Contraseña actual" placeholder="-" outline type="password" v-model='form.antiguaClave' @input="$v.form.antiguaClave.$touch()" @blur="$v.form.antiguaClave.$touch()" :error-messages="antiguaClaveErrors")
      v-flex(xs1 sm1 md2 lg2)
    //-- FORMULARIOS
    v-layout(row wrap)
      v-flex(xs1 sm1 md2 lg2)
      v-flex(xs10 sm10 md8 lg8)
        v-text-field.eye-password#inputPassword(label="Nueva contraseña" placeholder="-" outline :type="typePassword" hide-details v-model='form.clave' @keyup="isPasswordValid($event)" @input="$v.form.clave.$touch()" @blur="$v.form.clave.$touch()" @focus="showPasswordChecklist = true" :error-messages="claveErrors" :class="{'has-content': form.clave && form.clave.length > 0}")
          template(v-slot:append='')
            img(:src="icons.eyeSelected", alt="eyeClose", @click="showHidePassword()")
        //- BARRA DE PROGRESO Y CHECKLIST DE VALIDACIÓN
        .password-checklist.mt-2(v-if="showPasswordChecklist")
          .password-progress-container.mb-3
            .password-progress-bar
              .password-progress-fill(:style="{ width: passwordProgress + '%' }")
            p.password-progress-title.omnesMedium {{ passwordProgressText }}
          .password-requirement(v-for="(requirement, index) in passwordRequirements" :key="index")
            span.check-icon(:class="{'check-valid': requirement.valid && requirement.hasContent, 'check-invalid': !requirement.hasContent, 'check-error': requirement.hasContent && !requirement.valid}")
              img(v-if="requirement.valid && requirement.hasContent" :src="icons.checkValid" alt="check")
              img(v-else-if="requirement.hasContent && !requirement.valid" :src="icons.checkInvalid" alt="error")
            span.requirement-text {{ requirement.text }}
      v-flex(xs1 sm1 md2 lg2)
    v-layout.password-repeat-layout(row wrap)
      v-flex(xs1 sm1 md2 lg2)
      v-flex(xs10 sm10 md8 lg8)
        v-text-field#inputRepeatPassword(label="Reescribe nueva contraseña" placeholder="-" outline type="password" v-model='form.repetirClave' @input="$v.form.repetirClave.$touch()" @blur="$v.form.repetirClave.$touch()" :error-messages="repetirClaveErrors")
      v-flex(xs1 sm1 md2 lg2)
    //-- BOTON ACTUALIZAR
    v-layout(row wrap)
      v-flex(xs1 sm1 md2 lg2)
      v-flex(xs10 sm10 md8 lg8 id="extra-conditions")
        //- v-checkbox(v-model="form.conditions" color="#0855C4" label="Al continuar, acepto la actualización de los datos, los cuales serán utilizados como contacto legal para notificar la póliza y demás documentos asociados a su contrato.")
        p.disclaimer( v-bind:class="{ 'size-12px': $vuetify.breakpoint.smAndDown }")
          | Al continuar, acepto la actualización de los datos, los cuales serán utilizados como contacto legal para notificar la póliza y demás documentos asociados a su contrato.
        p.disclaimer.p2
          | Asimismo, acepto las&nbsp;
          a(href="https://documentos.interseguro.com.pe/PDF/PoliticaPrivacidadInterseguro.pdf" target="_blank" style="font-weight:bold") condiciones y políticas de privacidad.
        v-flex.btn--contain(xs12 sm12 md12 lg12)
          v-btn#update__profile.omnesRegular(type='button' :disabled="!isPasswordFormValid" @click="onSubmit") Actualizar
      v-flex(xs1 sm1 md2 lg2)
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, sameAs } from 'vuelidate/lib/validators'
import { validatePasswordFormat, PASSWORD_REGEX, validatePasswordError } from '@/utils/passwordValidation'

export default {
  data () {
    return {
      showProfileMob: false,
      showChangePass: false,
      passwordIsValid: true,
      showButtons: true,
      emailIsValid: false,
      panel: 0,
      showPasswordChecklist: false,
      form: {
        tipoDocumento: null,
        conditions: true,
        numeroDocumento: '',
        nombres: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        fechaNacimiento: '',
        telefono: '',
        celular: '',
        correo: '',
        antiguaClave: '',
        clave: '',
        repetirClave: ''
      },
      trackEvents: {
        update_ok: {
          category: 'Actualización de Datos',
          action: 'Acceso',
          label: 'Registro Exitoso',
          event: 'ACT_DATOS Exitoso'
        },
        pending: {
          category: 'Actualización de Datos',
          action: 'Error',
          label: 'Solicitud Pendiente',
          event: 'ACT_DATOS Solicitud Pendiente'
        },
        server_error: {
          category: 'Actualización de Datos',
          action: 'Error',
          label: 'Error del Servidor',
          event: 'ACT_DATOS Server Error'
        }
      },
      amplitude: {
        events: {
          personalDataUpdated: 'Datos Actualizados'
        }
      },
      type_documents: [
        { text: 'Selecciones una opcion', value: null },
        { text: 'DNI', value: 1 },
        { text: 'Carnet de Extranjeria', value: 2 }
      ],
      icons: {
        iconPencil: require('./../assets/cvc/icon_pencil_login.svg'),
        error: require('@/assets/characters/sorprendido.svg'),
        checkValid: require('@/assets/icons/icon-check-valid.svg'),
        checkInvalid: require('@/assets/icons/icon-check-invalid.svg'),
        eyeSelected: require('@/assets/icons/icon-eye-close.svg'),
        eyeClose: require('@/assets/icons/icon-eye-close.svg'),
        eyeOpen: require('@/assets/icons/icon-eye-open.svg')
      },
      showPassword: false,
      typePassword: 'password',
      files: {
        pdfPrivacy: require('./../assets/downloable/autorizacion-para-el-uso-y-tratamiento-de-datos-personales.pdf')
      }
    }
  },
  watch: {
    'form.correo': function (val) {
      // console.log('sVal: ', val)
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (val !== null) {
        if (re.test(val.toLowerCase())) {
          this.emailIsValid = true
        } else {
          this.emailIsValid = false
        }
      } else {
        this.emailIsValid = false
      }
    }
  },
  props: ['profile'],
  mounted () {
    this.init()
    // NUEVO: Verificar si viene del flujo de renovación (desde login con contraseña próxima a vencer)
    if (this.$route.query.renovar === 'true') {
      // El campo de contraseña actual ya se mostrará cuando el usuario escriba en "Nueva contraseña"
      // pero podemos forzar que se muestre si queremos, o dejarlo como está
    }
  },
  created () {
    var self = this
    this.$root.$on('hideDetailsProfile', function () {
      self.showProfileMob = false
      self.showChangePass = false
      self.showButtons = true
    })
  },
  computed: {
    ...mapGetters('user', ['userInfo', 'basicInfo']),
    correoErrors () {
      const errors = []
      if (!this.$v.form.correo.$dirty) return errors
      !this.$v.form.correo.required && errors.push('Este campo es requerido.')
      return errors
    },
    claveErrors () {
      const errors = []
      if (!this.$v.form.clave.$dirty) return errors
      return errors
    },
    repetirClaveErrors () {
      const errors = []
      if (!this.$v.form.repetirClave.$dirty) return errors
      !this.$v.form.repetirClave.sameAsClave && errors.push('Las contraseñas no coinciden.')
      return errors
    },
    antiguaClaveErrors () {
      const errors = []
      // Solo validar si se está cambiando la contraseña (nueva contraseña tiene contenido)
      if (!this.form.clave || this.form.clave.length === 0) return errors
      if (!this.$v.form.antiguaClave.$dirty) return errors
      // Validar que esté presente cuando se está cambiando la contraseña
      if (!this.form.antiguaClave || this.form.antiguaClave.length === 0) {
        errors.push('Este campo es requerido.')
      }
      return errors
    },
    passwordRequirements () {
      const password = this.form.clave || ''
      const currentPassword = this.form.antiguaClave || ''
      const hasContent = password.length > 0
      const hasCurrentPassword = currentPassword.length > 0
      const isDifferentFromCurrent = !hasCurrentPassword || password !== currentPassword
      
      return [
        {
          text: 'Al menos una mayúsculas y minúsculas.',
          valid: /[A-Z]/.test(password) && /[a-z]/.test(password),
          hasContent: hasContent
        },
        {
          text: 'Al menos un número.',
          valid: /\d/.test(password),
          hasContent: hasContent
        },
        {
          text: 'Al menos un carácter especial.',
          valid: /[^a-zA-Z0-9]/.test(password),
          hasContent: hasContent
        },
        {
          text: '8 caracteres como mínimo.',
          valid: password.length >= 8,
          hasContent: hasContent
        },
        {
          text: 'La nueva contraseña debe ser diferente a la anterior.',
          valid: isDifferentFromCurrent,
          hasContent: hasContent && hasCurrentPassword
        }
      ]
    },
    passwordProgress () {
      if (!this.form.clave || this.form.clave.length === 0) {
        return 0
      }
      const validCount = this.passwordRequirements.filter(req => req.valid).length
      return (validCount / 5) * 100
    },
    passwordProgressText () {
      if (!this.form.clave || this.form.clave.length === 0) {
        return 'Completa los requisitos de seguridad.'
      }
      const validCount = this.passwordRequirements.filter(req => req.valid).length
      switch (validCount) {
        case 0:
          return 'Completa los requisitos de seguridad.'
        case 1:
          return 'Completa los requisitos de seguridad.'
        case 2:
          return 'Vas completando los requisitos.'
        case 3:
          return 'Falta poco para completar los requisitos.'
        case 4:
          return 'Falta poco para completar los requisitos.'
        case 5:
          return 'Requisitos completos ¡Contraseña segura!'
        default:
          return 'Completa los requisitos de seguridad.'
      }
    },
    isPasswordFormValid () {
      // Si no hay contraseña nueva, el botón puede estar habilitado (para actualizar solo datos de contacto)
      if (!this.form.clave || this.form.clave.length === 0) {
        return true
      }
      
      // Si hay contraseña nueva, debe cumplir todos los requisitos de seguridad (incluye validación de contraseña actual y diferencia)
      const allRequirementsValid = this.passwordRequirements.every(req => req.valid)
      
      // Si no cumple los requisitos de seguridad, deshabilitar el botón
      if (!allRequirementsValid) {
        return false
      }
      
      // Validar que la contraseña actual esté presente cuando se está cambiando la contraseña
      if (!this.form.antiguaClave || this.form.antiguaClave.length === 0) {
        return false
      }
      
      // Si cumple los requisitos, verificar que las contraseñas coincidan
      // Si hay contraseña repetida escrita, deben coincidir
      if (this.form.repetirClave && this.form.repetirClave.length > 0) {
        return this.$v.form.repetirClave.sameAsClave
      }
      
      // Si no hay contraseña repetida aún, deshabilitar hasta que la escriba
      return false
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {
    form: {
      correo: {
        required
      },
      antiguaClave: {
        // Solo es requerida cuando el usuario quiere cambiar la contraseña.
        required: function (value) {
          if (!this.form.clave || this.form.clave.length === 0) {
            return true
          }
          return !!(value && value.length > 0)
        }
      },
      clave: {},
      repetirClave: {
        sameAsClave: sameAs('clave')
      }
    }
  },
  methods: {
    ...mapActions('user', ['getUserInfo', 'updatePassword', 'sendDataToRequirements', 'checkIfPolicyHasPendingOkActDatos']),
    init () {
      if (this.basicInfo == null) {
        this.getUserInfo(this.userInfo).then(res => {
          if (res.data.codigoRespuesta === '01') {
            // Check what type document is
            if (res.data.tipoDocumento === 'DNI') {
              this.form.tipoDocumento = 'DNI'
            } else {
              this.form.tipoDocumento = 'CARNET DE EXTRANJERÍA'
            }
            // Set data for user
            this.form.numeroDocumento = res.data.numeroDocumento
            this.form.nombres = res.data.nombres !== '' ? res.data.nombres : '-'
            this.form.apellidoPaterno = res.data.apellidoPaterno !== '' && res.data.apellidoPaterno !== ' ' ? res.data.apellidoPaterno : '-'
            this.form.apellidoMaterno = res.data.apellidoMaterno !== '' && res.data.apellidoMaterno !== ' ' ? res.data.apellidoMaterno : '-'
            this.form.fechaNacimiento = res.data.fechaNacimiento !== null ? res.data.fechaNacimiento : '-'
            this.form.telefono = res.data.telefono !== '' ? res.data.telefono : '-'
            this.form.celular = res.data.celular !== '' ? res.data.celular : '-'
            this.form.correo = res.data.correo !== '' ? res.data.correo : '-'
          }
        })
      } else {
        if (this.basicInfo.tipoDocumento === 'DNI') {
          this.form.tipoDocumento = 'DNI'
        } else {
          this.form.tipoDocumento = 'CARNET DE EXTRANJERÍA'
        }
        // Set data for user
        this.form.numeroDocumento = this.basicInfo.numeroDocumento
        this.form.nombres = this.basicInfo.nombres !== '' ? this.basicInfo.nombres : '-'
        this.form.apellidoPaterno = this.basicInfo.apellidoPaterno !== '' && this.basicInfo.apellidoPaterno !== ' ' ? this.basicInfo.apellidoPaterno : '-'
        this.form.apellidoMaterno = this.basicInfo.apellidoMaterno !== '' && this.basicInfo.apellidoMaterno !== ' ' ? this.basicInfo.apellidoMaterno : '-'
        this.form.fechaNacimiento = this.basicInfo.fechaNacimiento !== null ? this.basicInfo.fechaNacimiento : '-'
        this.form.telefono = this.basicInfo.telefono !== '' ? this.basicInfo.telefono : '-'
        this.form.celular = this.basicInfo.celular !== '' ? this.basicInfo.celular : '-'
        this.form.correo = this.basicInfo.correo !== '' ? this.basicInfo.correo : '-'
      }
    },
    showMyData () {
      this.showButtons = false
      this.showProfileMob = true
      this.$root.$emit('displayFormProfile', 'VER MIS DATOS')
    },
    showChangePassword () {
      this.showButtons = false
      this.showChangePass = true
      this.$root.$emit('displayChangePassword', 'MODIFICAR CONTRASEÑA')
    },
    onlyNumbers (e) {
      if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault()
      }
    },
    isPasswordValid (e) {
      let sVal = this.form.clave || ''
      if (sVal.length > 20) {
        this.passwordIsValid = false
      } else {
        const validation = validatePasswordFormat(sVal)
        this.passwordIsValid = validation.isValid
      }
    },
    showHidePassword () {
      if (this.showPassword) {
        this.showPassword = false
        this.typePassword = 'password'
        this.icons.eyeSelected = this.icons.eyeClose
      } else {
        this.showPassword = true
        this.typePassword = 'text'
        this.icons.eyeSelected = this.icons.eyeOpen
      }
    },
    updatePasswordBorder () {
      // Este método se usa para forzar la actualización del borde
      // La lógica real está en CSS usando las clases
      this.$forceUpdate()
    },
    onSubmit (evt) {
      const self = this
      evt.preventDefault()
      this.$v.$touch()
      let msg = ''
      // EVENT TRACK  Universal Analytics
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Mi perfil - Actualizar mis datos',
        label: 'Seleccionar botón - Actualizar'
      })
      // EVENT TRACK  GA4
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Mi perfil - Actualizar mis datos',
        CTA: 'Seleccionar botón - Actualizar'
      })
      // NUEVO: Verificar si hay algún cambio ANTES de cualquier otra validación
      // Verificar que basicInfo esté disponible
      if (!this.basicInfo) {
        console.error('basicInfo no está disponible')
        return
      }

      // Normalizar valores para comparación (trim y manejar null/undefined)
      const formCelular = (this.form.celular || '').trim()
      const basicCelular = (this.basicInfo.celular || '').trim()
      const formCorreo = (this.form.correo || '').trim()
      const basicCorreo = (this.basicInfo.correo || '').trim()
      
      const hasCelularChange = formCelular !== basicCelular
      const hasCorreoChange = formCorreo !== basicCorreo
      const hasPasswordChange = this.form.clave && this.form.clave.trim().length > 0
      const hasAnyChange = hasCelularChange || hasCorreoChange || hasPasswordChange

      // Si NO hay ningún cambio, mostrar el mensaje de aviso INMEDIATAMENTE
      if (!hasAnyChange) {
        this.$swal({
          title: '¡Aviso!',
          text: 'No detectamos alguna modificación en tus datos o contraseña.',
          confirmButtonText: 'Ok'
        })
        return // Salir sin procesar
      }

      // console.log('emailIsValid: ', this.emailIsValid)
      
      // PRIMERO: Verificar si hay cambios antes de validar el formulario
      const hasPersonalDataChanges = (this.form.celular !== this.basicInfo.celular) || (this.form.correo !== this.basicInfo.correo)
      const hasNewPassword = this.form.clave && this.form.clave.trim().length > 0
      const hasAnyChanges = hasPersonalDataChanges || hasNewPassword
      
      // Si no hay cambios, mostrar popup directamente sin validar formulario
      if (!hasAnyChanges) {
        this.$swal({
          title: '¡Aviso!',
          text: 'No detectamos alguna modificación en tus datos o contraseña.',
          confirmButtonText: 'Ok'
        })
        return
      }
      
      // Si hay cambios, validar email y formulario
      if (!this.emailIsValid) {
        this.$swal({
          title: '¡Aviso!',
          text: 'El correo electrónico ingresado parece estar errado. Por favor, inténtalo nuevamente.',
          confirmButtonText: 'Ok'
        })
      } else {
        if (this.$v.$invalid) {
          this.$swal({
            title: '¡Aviso!',
            text: 'Verifica los campos ingresados antes de continuar.',
            confirmButtonText: 'Ok'
          })
        } else {

          let hash = {}
          let form = {
            transact: 'Actualización de datos',
            name: this.basicInfo.nombres,
            product: 'Verificar Bases',
            policy: 'Verificar Bases',
            home_address: 'No aplica',
            department: 'No aplica',
            province: 'No aplica',
            district: 'No aplica',
            state: 'PENDIENTE',
            paternal_surname: this.basicInfo.apellidoPaterno,
            maternal_surname: this.basicInfo.apellidoMaterno,
            type_document: this.basicInfo.tipoDocumento,
            number_document: this.basicInfo.numeroDocumento,
            cellphone: this.form.celular,
            phone: 'No aplica',
            email: this.form.correo
          }
          // SI HUBO ALGUNA MODIFICACION EN SUS DATOS PERSONALES
          if (hasPersonalDataChanges) {
            msg = 'Tus datos personales ingresados serán modificados durante las próximas 24 horas.'
            // VERIFICAMOS SI TIENES ALGUN PENDIENTE EN ACT_DATOS
            this.checkIfPolicyHasPendingOkActDatos({ numDoc: this.basicInfo.numeroDocumento })
              .then((res) => {
                const pendingRequirements = Array.isArray(res.data)
                  ? res.data
                  : (res.data && Array.isArray(res.data.data) ? res.data.data : [])

                if (pendingRequirements.length < 1) {
                  // SI PUSO PARA ACTUALIZAR CLAVE TAMBIEN
                  if (this.form.clave !== '') {
                    msg = 'Tu contraseña fue actualizada y tus datos personales serán modificados durante las próximas 24 horas.'
                    hash = {
                      // 'codigoUsuario': this.userInfo.codigoUsuario,
                      'clave': this.form.clave
                    }
                    // NUEVO: Incluir contraseña actual para validación en backend
                    if (this.form.antiguaClave && this.form.antiguaClave.length > 0) {
                      const sanitized = this.form.antiguaClave.replace(/[\x00-\x1F\x7F]/g, '')
                      hash.claveActual = sanitized
                    }
                  }
                  // SI NO ACEPTA LAS CONDICIONES, ENVIAR UN ESTADO PARA QUE NO PROCESE EL BOT LA ACTUALIZACIÓN
                  /*
                  if (!this.form.conditions) {
                    msg = 'Los datos personales ingresados no serán modificados dado que no se aceptó la conformidad de la actualización de las mismas. Sin embargo, si has actualizado tu clave esta se reflejará al instante.'
                    form.state = 'COMERCIAL'
                  }
                  */
                  // HACER EL(LOS) UPDATE(S) CORRESPONDIENTE(S)
                  if (this.form.clave !== '') {
                    // TRACK EVENT - AMPLITUDE
                    this.$amplitude.getInstance()
                      .logEvent(
                        this.amplitude.events.personalDataUpdated,
                        {
                          'Cambio de Password': true,
                          'Email': this.form.correo,
                          'Teléfono': this.form.celular
                        }
                      )
                    // ENVIANMOS LA DATA A LA DB DE REQUERIMIENTOS Y EL PASS AL MONGODB
                    this.sendDataToRequirements(form)
                      .then((res) => {
                        this.updatePassword(hash)
                          .then((res) => {
                            // this.$gtm.trackEvent(this.trackEvents.update_ok)
                            this.$swal({
                              title: '¡Éxito!',
                              text: msg,
                              confirmButtonText: 'Ok'
                            }).then(() => {
                              // Limpiar campos de contraseña después de actualización exitosa
                              this.form.antiguaClave = ''
                              this.form.clave = ''
                              this.form.repetirClave = ''
                              this.showPasswordChecklist = false
                              this.passwordIsValid = true
                              this.$v.form.antiguaClave.$reset()
                              this.$v.form.clave.$reset()
                              this.$v.form.repetirClave.$reset()

                              // #004.24: Elemento - Actualización de datos
                              this.updateDataAnalytics()

                              // Redirigir al home después de actualizar contraseña
                              this.$router.push({ name: 'Home' }).catch(() => {})
                            })
                          })
                          .catch((err) => {
                            // Manejo mejorado de errores específicos del backend usando helper
                            if (!err.data || !err.data.mensajeRespuesta) {
                              return
                            }

                            const errorType = validatePasswordError(err.data.mensajeRespuesta)
                            if (!errorType) {
                              return
                            }

                            switch (errorType) {
                              case 'INVALID_CURRENT':
                                this.$swal({
                                  titleText: 'Error de validación',
                                  text: 'La contraseña actual ingresada es incorrecta.',
                                  confirmButtonText: 'Entendido'
                                })
                                return

                              case 'SAME_PASSWORD':
                                this.$swal({
                                  titleText: 'Error de validación',
                                  text: 'La nueva contraseña debe ser distinta a la actual.',
                                  confirmButtonText: 'Entendido'
                                })
                                return

                              case 'INVALID_FORMAT':
                                this.$swal({
                                  titleText: 'Error de validación',
                                  text: err.data.mensajeRespuesta || 'La contraseña no cumple con el formato requerido',
                                  confirmButtonText: 'Entendido'
                                })
                                return
                            }

                            // Error genérico si no es un error de contraseña conocido
                            // this.$gtm.trackEvent(this.trackEvents.server_error)
                            this.$swal({
                              imageUrl: this.icons.error,
                              title: '¡Lo sentimos!',
                              text: 'Algo salió mal. Por favor, vuelve a intentarlo en 1 hora o comunícate con nuestro Servicio de Atención al Cliente.',
                              confirmButtonText: 'Ok'
                            })
                          })
                      })
                      .catch(() => {
                        // this.$gtm.trackEvent(this.trackEvents.server_error)
                        this.$swal({
                          imageUrl: this.icons.error,
                          title: '¡Lo sentimos!',
                          text: 'Algo salió mal. Por favor, vuelve a intentarlo en 1 hora o comunícate con nuestro Servicio de Atención al Cliente.',
                          confirmButtonText: 'Ok'
                        })
                      })
                  } else {
                    // TRACK EVENT - AMPLITUDE
                    this.$amplitude.getInstance()
                      .logEvent(
                        this.amplitude.events.personalDataUpdated,
                        {
                          'Cambio de Password': false,
                          'Email': this.form.correo,
                          'Teléfono': this.form.celular
                        }
                      )
                    // SOLO ENVIANMOS LA DATA A LA DB DE REQUERIMIENTOS
                    this.sendDataToRequirements(form)
                      .then((res) => {
                        // this.$gtm.trackEvent(this.trackEvents.update_ok)
                        this.$swal({
                          title: '¡Éxito!',
                          text: msg,
                          confirmButtonText: 'Ok'
                        })

                        // #004.24: Elemento - Actualización de datos
                        this.updateDataAnalytics()
                      })
                      .catch(() => {
                        // this.$gtm.trackEvent(this.trackEvents.server_error)
                        this.$swal({
                          imageUrl: this.icons.error,
                          title: '¡Lo sentimos!',
                          text: 'Algo salió mal. Por favor, vuelve a intentarlo en 1 hora o comunícate con nuestro Servicio de Atención al Cliente.',
                          confirmButtonText: 'Ok'
                        })
                      })
                  }
                } else {
                  // this.$gtm.trackEvent(this.trackEvents.pending)
                  this.$swal({
                    title: '¡Solicitud en proceso!',
                    html: 'Tu solicitud de actualización de datos se encuentra en proceso. Podrás volver a intentarlo en 24 horas.',
                    confirmButtonText: 'Ok'
                  })
                }
                setTimeout(() => {
                  self.$root.$emit('showNps', {nombre: 'NPS - Inicio de Encuesta', funcionalidad: 'Solicitud Actualización de datos'})
                }, 3000)
              })
              .catch(() => {
                // this.$gtm.trackEvent(this.trackEvents.server_error)
                this.$swal({
                  imageUrl: this.icons.error,
                  title: '¡Lo sentimos!',
                  text: 'Algo salió mal. Por favor, vuelve a intentarlo en 1 hora o comunícate con nuestro Servicio de Atención al Cliente.',
                  confirmButtonText: 'Ok'
                })
                setTimeout(() => {
                  self.$root.$emit('showNps', {nombre: 'NPS - Inicio de Encuesta', funcionalidad: 'Solicitud Actualización de datos'})
                }, 3000)
              })
          } else {
            // SI NO HUBO MODIFICACION EN DATOS PERSONALES PERO HAY CONTRASEÑA NUEVA
            // (Ya verificamos que hay cambios al inicio, así que si llegamos aquí es porque hay contraseña nueva)
            // TRACK EVENT - AMPLITUDE
            this.$amplitude.getInstance()
              .logEvent(
                this.amplitude.events.personalDataUpdated,
                {
                  'Cambio de Password': true
                }
              )
            if (this.form.clave !== '') {
              msg = 'Tu contraseña fue actualizada.'
              hash = {
                'codigoUsuario': this.userInfo.codigoUsuario,
                'clave': this.form.clave
              }
              // NUEVO: Incluir contraseña actual para validación en backend
              if (this.form.antiguaClave && this.form.antiguaClave.length > 0) {
                const sanitized = this.form.antiguaClave.replace(/[\x00-\x1F\x7F]/g, '')
                hash.claveActual = sanitized
              }
              // ACTUALIZAR
              // UPDATE DEL PASSWORD
              this.updatePassword(hash)
                .then((res) => {
                  this.$swal({
                    title: '¡Éxito!',
                    text: msg,
                    confirmButtonText: 'Ok'
                  }).then(() => {
                    // Limpiar campos de contraseña después de actualización exitosa
                    this.form.antiguaClave = ''
                    this.form.clave = ''
                    this.form.repetirClave = ''
                    this.showPasswordChecklist = false
                    this.passwordIsValid = true
                    this.$v.form.antiguaClave.$reset()
                    this.$v.form.clave.$reset()
                    this.$v.form.repetirClave.$reset()

                    // #004.24: Elemento - Actualización de datos
                    this.updateDataAnalytics()

                    // Redirigir al home después de actualizar contraseña
                    this.$router.push({ name: 'Home' }).catch(() => {})
                  })
                })
                .catch((err) => {
                  // Manejo mejorado de errores específicos del backend usando helper
                  if (!err.data || !err.data.mensajeRespuesta) {
                    return
                  }

                  const errorType = validatePasswordError(err.data.mensajeRespuesta)
                  if (!errorType) {
                    return
                  }

                  switch (errorType) {
                    case 'INVALID_CURRENT':
                      this.$swal({
                        titleText: 'Error de validación',
                        text: 'La contraseña actual ingresada es incorrecta.',
                        confirmButtonText: 'Entendido'
                      })
                      return

                    case 'SAME_PASSWORD':
                      this.$swal({
                        titleText: 'Error de validación',
                        text: 'La nueva contraseña debe ser distinta a la actual.',
                        confirmButtonText: 'Entendido'
                      })
                      return

                    case 'INVALID_FORMAT':
                      this.$swal({
                        titleText: 'Error de validación',
                        text: err.data.mensajeRespuesta || 'La contraseña no cumple con el formato requerido',
                        confirmButtonText: 'Entendido'
                      })
                      return
                  }

                  // Error genérico si no es un error de contraseña conocido
                  // this.$gtm.trackEvent(this.trackEvents.server_error)
                  this.$swal({
                    imageUrl: this.icons.error,
                    title: '¡Lo sentimos!',
                    text: 'Algo salió mal. Por favor, vuelve a intentarlo en 1 hora o comunícate con nuestro Servicio de Atención al Cliente.',
                    confirmButtonText: 'Ok'
                  })
                })
            }
          }
        }
      }
    },
    // #004.24: Elemento - Actualización de datos
    updateDataAnalytics () {
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Zona Segura',
        'action': 'Crear cuenta - Actualizar datos - Paso 2',
        'label': 'Seleccionar botón - Actualizar'
      })

      this.$gtm.trackEvent({
        'event': 'select_button',
        'Nombre Sección': 'Zona Segura',
        'TipoElemento': 'Botón',
        'TipoAccion': 'Crear cuenta - Actualizar datos - Paso 2',
        'CTA': 'Seleccionar botón - Actualizar'
      })
    }
  }
}
</script>

<style>
  #form__profile h3 {
    color: #1361B9;
    text-transform: uppercase;
    margin-bottom: 1.5em;
  }
  #form__profile h3#personal_info { margin-top: 0.6em; }
  #form__profile h3#contact_info { margin-top: 1.3em; }
  #form__profile h3#change_credentials { margin-top: 1.3em; }
  button#update__profile {
    font-size: 18px;
    background-color: var(--fuchsia-color);
    color: #fff;
    text-transform: initial;
    -webkit-border-radius: 29px;
    -moz-border-radius: 29px;
    border-radius: 7px;
    width: 65%;
    height: auto;
    padding: 12px 0;
  }
  #container__profile .v-text-field .v-input__control .v-input__slot .v-text-field__slot input { font-size: 12px; }
  .btn-show-data {
    background-color: var(--second-brand-color) !important;
    color: #FFF !important;
    height: auto;
    padding: 12px 29px;
    font-size: 19px;
    width: 96%;
    text-transform: initial;
  }
  .btn-show-data .v-btn__content, .show-change-password .v-btn__content {
    display: block;
    text-align: left;
  }
  .btn-show-data .v-btn__content i, .show-change-password .v-btn__content i {
    float: right;
    font-size: 28px;
  }
  .show-change-password {
    background-color: #0855C4 !important;
    color: #FFF !important;
    height: auto;
    padding: 12px 29px;
    font-size: 19px;
    width: 96%;
    text-transform: initial;
  }
  p.disclaimer { font-size: 13px; text-align: center;}
  p.disclaimer.p2 { text-align: center; }
  h2.subtitle-profile {
    color: #0855C4;
    font-size: 19px;
    font-weight: normal;
    margin-bottom: 1em;
    margin-top: 1em;
  }
  .btn--contain { text-align: center; }
  #form-profile .layout .flex .v-text-field .v-input__control .v-input__slot {
    border: 1px solid #B2B4C7;
    
  }
  #form-profile .layout .current-password .v-text-field .v-input__control .v-input__slot {
    margin-bottom: 0px;
    
  } 
  #extra-conditions .v-input--checkbox .v-input__control .v-input__slot label {
    font-family: 'Omnes Regular';
    color: #242424;
    font-size: 14px;
    line-height: 1;
  }
  .disclaimer{
    color:#454A6C;
  }

  @media only screen and (max-width : 600px) {
    p.disclaimer, p.disclaimer.p2 {
      text-align: justify;
    }
  }
  /* Desktop ----------- */
  @media only screen  and (min-width : 1265px) {}
  /* iPhone 6, 7, & 8 in portrait & landscape ----------- */
  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) {
    #form-profile { margin-bottom: 2.5em; }
  }
  /* iPhone X in portrait & landscape ----------- */
  @media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-device-pixel-ratio: 3) {
    #form-profile { margin-bottom: 2.5em; }
  }
  /* iPhone XR in portrait & landscape ----------- */
  @media only screen and (device-width : 414px) and (device-height : 896px) and (-webkit-device-pixel-ratio : 2) {
    #form-profile { margin-bottom: 2.5em; }
  }
  /* ----------- Galaxy Phones ----------- */
  /* Portrait and Landscape */
  @media screen and (-webkit-min-device-pixel-ratio: 3) and (min-resolution: 192dpi) and (max-width: 640px) {
    #form-profile { margin-bottom: 2.5em; }
  }
  /* Password Checklist Styles */
  .password-checklist {
    background-color: white;
    padding: 12px;
    margin-top: 8px;
    margin-bottom: 0;
    border: 1px solid #919191;
  }
  .password-repeat-layout {
    margin-top: 16px;
  }
  .password-progress-container {
    margin-bottom: 12px;
  }
  .password-progress-bar {
    width: 100%;
    height: 4px;
    background-color: #919191;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 8px;
  }
  .password-progress-fill {
    height: 100%;
    background-color: #1FAF38;
    border-radius: 4px;
    transition: width 0.3s ease;
  }
  .password-progress-title {
    font-size: 13px;
    color: #454A6C;
  }
  .password-description {
    font-size: 13px;
    color: #454A6C;
    font-family: 'Omnes Regular';
    line-height: 1.4;
  }
  @media only screen and (max-width: 600px) {
    .password-description {
      text-align: center;
    }
  }
  .password-requirement {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    font-size: 13px;
  }
  .password-requirement:last-child {
    margin-bottom: 0;
  }
  .check-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    margin-right: 8px;
    flex-shrink: 0;
  }
  .check-icon img {
    width: 100%;
    height: 100%;
    display: block;
  }
  .check-invalid {
    background-color: white;
    border: 1px solid #B1B8C4;
    border-radius: 50%;
  }
  .check-error {
    background-color: white;
    /* border: 1px solid #F44336; */
    border-radius: 50%;
  }
  .requirement-text {
    font-family: 'Omnes Regular';
    color: #424242;
  }
  .v-input.eye-password .v-input__control .v-input__slot .v-input__append-inner {
    justify-content: flex-end;
    padding-right: 4px;
  }
  .v-input.eye-password .v-input__control .v-input__slot .v-input__append-inner img {
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    cursor: pointer;
  }
  /* Borde azul cuando está en focus y está vacío */
  .v-input.eye-password.v-input--is-focused:not(.has-content) .v-input__control .v-input__slot {
    border: 1px solid #0855C4 !important;
  }
  /* Borde gris cuando tiene contenido (sobrescribe el azul incluso en focus) */
  .v-input.eye-password.has-content .v-input__control .v-input__slot {
    border: 1px solid #B2B4C7 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/FormProfile.vue